import { Star, Quote } from "lucide-react";

const T = [
  {
    name: "Nicola",
    role: "Move Apartment",
    stars: 5,
    text: "Oh, wie geil. Ich gucke gleich mal nach. Tausend Dank. Das ist echt 'ne Welt für sich. Ich hoffe, dass ab jetzt nur noch positive Bewertungen kommen. Jetzt habe ich volle 5 Sterne.",
    label: "Direktes Feedback nach erfolgreicher Löschung",
  },
  {
    name: "Unternehmer (Übernahme)",
    role: "während der Zusammenarbeit",
    stars: 5,
    text: "Ich war am Anfang skeptisch und habe es vorher selbst versucht. Mir wurde verständlich erklärt, was machbar ist und was nicht. Keine leeren Versprechen, sondern klare Aussagen. Das hat mir direkt ein besseres Gefühl gegeben.",
    label: "Zusammenarbeit läuft aktuell",
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials" className="relative py-20 lg:py-28 border-t border-black/[0.05]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#2b2620]">Kundenstimmen</div>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-[#2b2620]">
            Klar formuliert. Ehrlich kommuniziert.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-6">
          {T.map((t, i) => (
            <figure
              key={t.name}
              data-testid={`testimonial-${i + 1}`}
              className="relative bg-[#faf6ef] border border-black/[0.08] rounded-3xl p-8 lg:p-10 hover:border-[#2b2620]/30 transition-all"
            >
              <Quote className="absolute top-6 right-6 w-10 h-10 text-[#2b2620]/15" />
              <div className="flex gap-1">
                {Array.from({ length: t.stars }).map((_, idx) => (
                  <Star key={idx} className="w-4 h-4 fill-[#2b2620] text-[#2b2620]" />
                ))}
              </div>
              <div className="mt-3 text-xs uppercase tracking-[0.18em] text-[#8a7f70]">{t.label}</div>
              <blockquote className="mt-5 text-[#3a3128] leading-relaxed">
                &bdquo;{t.text}&ldquo;
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#2b2620] to-[#6b6c75] flex items-center justify-center text-white font-semibold">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="text-sm font-medium text-[#2b2620]">{t.name}</div>
                  <div className="text-xs text-[#8a7f70]">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
